import { createClient } from '@supabase/supabase-js';

if (!import.meta.env.VITE_SUPABASE_URL) {
  throw new Error('Missing VITE_SUPABASE_URL environment variable');
}

if (!import.meta.env.VITE_SUPABASE_ANON_KEY) {
  throw new Error('Missing VITE_SUPABASE_ANON_KEY environment variable');
}

// Initialize the Supabase client with robust session handling
export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storage: window.localStorage,
      storageKey: 'supabase.auth.token',
      flowType: 'pkce'
    },
    global: {
      headers: {
        'x-client-info': 'vite-react-typescript-starter'
      }
    }
  }
);

// Set up auth state listener to handle session changes
supabase.auth.onAuthStateChange((event, session) => {
  if (event === 'SIGNED_OUT' || event === 'TOKEN_REFRESHED') {
    // Clear any cached data if needed
    localStorage.removeItem('user-data');
  }
});

// Initialize auth state and handle session recovery
const initializeAuth = async () => {
  try {
    const { data: { session }, error } = await supabase.auth.getSession();
    
    if (error) {
      console.error('Error getting session:', error.message);
      // Clear invalid session data
      await supabase.auth.signOut();
      return;
    }

    if (!session) {
      console.log('No active session');
      return;
    }

    // Attempt to refresh the session if it exists
    const { error: refreshError } = await supabase.auth.refreshSession();
    if (refreshError) {
      console.error('Error refreshing session:', refreshError.message);
      // Clear invalid session
      await supabase.auth.signOut();
    }
  } catch (error) {
    console.error('Error during auth initialization:', error);
    // Ensure we clear any invalid session state
    await supabase.auth.signOut();
  }
};

// Initialize auth state
initializeAuth().catch(console.error);